
<template>
    
</template>

<script>
    export default {
        data() {
            return {
                //
            }
        },
        mounted: function () {
            $( window ).on( 'load', () => {
                $( '#page-loader' ).remove();
            });
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #page-loader {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba( 255, 255, 255, 1 );
        z-index: 9999;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PageLoader.vue